import { __decorate, __extends } from "tslib";
import { attachShadowTemplate, coerceBoolean, coerceNumber, CustomElement, ensureChild, FoundationProperty, upgradeProperty } from '@tyler-components-web/core';
import { CalendarComponent } from '../calendar';
import { DialogComponent } from '../dialog';
import { IconButtonComponent } from '../icon-button';
import { PopupComponent } from '../popup';
import { ScaffoldComponent } from '../scaffold';
import { ToolbarComponent } from '../toolbar';
import { DateRangePickerAdapter } from './date-range-picker-adapter';
import { DATE_RANGE_PICKER_CONSTANTS } from './date-range-picker-constants';
import { DateRangePickerFoundation } from './date-range-picker-foundation';
import { TylerIconRegistry, IconComponent } from '../icon';
import { tylIconDateRange } from '@tylertech/tyler-icons/standard';
import { coerceNumberArray } from '../core';
var template = require('./date-range-picker.html');
var styles = require('./date-range-picker.css');
var DateRangePickerComponent = /** @class */ (function (_super) {
    __extends(DateRangePickerComponent, _super);
    function DateRangePickerComponent() {
        var _this = _super.call(this) || this;
        TylerIconRegistry.define(tylIconDateRange);
        attachShadowTemplate(_this, DATE_RANGE_PICKER_CONSTANTS.elementName, template, styles);
        _this._foundation = new DateRangePickerFoundation(new DateRangePickerAdapter(_this));
        return _this;
    }
    Object.defineProperty(DateRangePickerComponent, "observedAttributes", {
        get: function () {
            return [
                DATE_RANGE_PICKER_CONSTANTS.attributes.FROM,
                DATE_RANGE_PICKER_CONSTANTS.attributes.TO,
                DATE_RANGE_PICKER_CONSTANTS.attributes.MIN,
                DATE_RANGE_PICKER_CONSTANTS.attributes.MAX,
                DATE_RANGE_PICKER_CONSTANTS.attributes.OPEN,
                DATE_RANGE_PICKER_CONSTANTS.attributes.DISABLED,
                DATE_RANGE_PICKER_CONSTANTS.attributes.MASKED,
                DATE_RANGE_PICKER_CONSTANTS.attributes.MASK_FORMAT,
                DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_MASK_FORMAT,
                DATE_RANGE_PICKER_CONSTANTS.attributes.USE_CHAR_MASK,
                DATE_RANGE_PICKER_CONSTANTS.attributes.VALUE_MODE,
                DATE_RANGE_PICKER_CONSTANTS.attributes.POPUP_CLASSES,
                DATE_RANGE_PICKER_CONSTANTS.attributes.DIALOG_WIDTH_THRESHOLD,
                DATE_RANGE_PICKER_CONSTANTS.attributes.ALLOW_INVALID_DATE,
                DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_TODAY,
                DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_CLEAR,
                DATE_RANGE_PICKER_CONSTANTS.attributes.DISABLED_DAYS_OF_WEEK
            ];
        },
        enumerable: true,
        configurable: true
    });
    DateRangePickerComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'from');
        upgradeProperty(this, 'to');
        upgradeProperty(this, 'min');
        upgradeProperty(this, 'max');
        upgradeProperty(this, 'blockedDates');
        upgradeProperty(this, 'open');
        upgradeProperty(this, 'parseCallback');
        upgradeProperty(this, 'formatCallback');
        upgradeProperty(this, 'prepareMaskCallback');
        upgradeProperty(this, 'popupClasses');
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'masked');
        upgradeProperty(this, 'maskFormat');
        upgradeProperty(this, 'showMaskFormat');
        upgradeProperty(this, 'useCharMask');
        upgradeProperty(this, 'valueMode');
        upgradeProperty(this, 'dialogWidthThreshold');
        upgradeProperty(this, 'notifyInputValueChanges');
        upgradeProperty(this, 'allowInvalidDate');
        upgradeProperty(this, 'showToday');
        upgradeProperty(this, 'showClear');
        upgradeProperty(this, 'disabledDaysOfWeek');
        upgradeProperty(this, 'disableDayCallback');
    };
    DateRangePickerComponent.prototype.connectedCallback = function () {
        var _this = this;
        if (this.querySelector('input')) {
            this._foundation.initialize();
        }
        else {
            ensureChild(this, 'input').then(function () { return _this._foundation.initialize(); });
        }
    };
    DateRangePickerComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    DateRangePickerComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case DATE_RANGE_PICKER_CONSTANTS.attributes.FROM:
                this.from = newValue;
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.TO:
                this.to = newValue;
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.MIN:
                this.min = newValue;
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.MAX:
                this.max = newValue;
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.OPEN:
                this.open = this.hasAttribute(DATE_RANGE_PICKER_CONSTANTS.attributes.OPEN);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.POPUP_CLASSES:
                this.popupClasses = newValue;
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(DATE_RANGE_PICKER_CONSTANTS.attributes.DISABLED);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.MASKED:
                this.masked = coerceBoolean(newValue);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_MASK_FORMAT:
                this.showMaskFormat = coerceBoolean(newValue);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.MASK_FORMAT:
                this.maskFormat = newValue;
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.USE_CHAR_MASK:
                this.useCharMask = coerceBoolean(newValue);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.VALUE_MODE:
                this.valueMode = newValue;
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.DIALOG_WIDTH_THRESHOLD:
                this.dialogWidthThreshold = coerceNumber(newValue);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.ALLOW_INVALID_DATE:
                this.allowInvalidDate = this.hasAttribute(DATE_RANGE_PICKER_CONSTANTS.attributes.ALLOW_INVALID_DATE);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_TODAY:
                this.showToday = this.hasAttribute(DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_TODAY);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_CLEAR:
                this.showClear = this.hasAttribute(DATE_RANGE_PICKER_CONSTANTS.attributes.SHOW_CLEAR);
                break;
            case DATE_RANGE_PICKER_CONSTANTS.attributes.DISABLED_DAYS_OF_WEEK:
                this.disabledDaysOfWeek = coerceNumberArray(newValue);
                break;
        }
    };
    Object.defineProperty(DateRangePickerComponent.prototype, "from", {
        /** Gets/sets the date value. */
        get: function () {
            return this._foundation.from;
        },
        set: function (value) {
            this._foundation.from = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "to", {
        /** Gets/sets the date value. */
        get: function () {
            return this._foundation.to;
        },
        set: function (value) {
            this._foundation.to = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "min", {
        /** Gets/sets the minimum date the calendar will allow. */
        get: function () {
            return this._foundation.min;
        },
        set: function (value) {
            this._foundation.min = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "max", {
        /** Gets/sets the maximum date the calendar will allow. */
        get: function () {
            return this._foundation.max;
        },
        set: function (value) {
            this._foundation.max = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "blockedDates", {
        /** Gets/sets the dates that are restricted from being selected. */
        get: function () {
            return this._foundation.blockedDates;
        },
        set: function (value) {
            this._foundation.blockedDates = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "open", {
        /** Gets/sets whether the datepicker is open. */
        get: function () {
            return this._foundation.open;
        },
        set: function (value) {
            this._foundation.open = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "popupClasses", {
        /** Gets/sets the CSS classes that are applied to the popup element. */
        get: function () {
            return this._foundation.popupClasses;
        },
        set: function (value) {
            this._foundation.popupClasses = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "disabled", {
        /** Gets/sets whether the datepicker is disabled or not. */
        get: function () {
            return this._foundation.disabled;
        },
        set: function (value) {
            this._foundation.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "masked", {
        /** Gets/sets whether the input mask is applied or not. */
        get: function () {
            return this._foundation.masked;
        },
        set: function (value) {
            this._foundation.masked = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "maskFormat", {
        /** Gets/sets the mask format that displayed in the input. Default is `MM/DD/YYYY` */
        get: function () {
            return this._foundation.maskFormat;
        },
        set: function (value) {
            this._foundation.maskFormat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "showMaskFormat", {
        /** Gets/sets whether the mask format is displayed in the input or not. Only applies if `masked` is `true`. */
        get: function () {
            return this._foundation.showMaskFormat;
        },
        set: function (value) {
            this._foundation.showMaskFormat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "useCharMask", {
        /**
         * Gets/sets whether the mask format uses the default placeholder (`__/__/___`) or the block
         * identifier (`MM/DD/YYYY`). Only pertains if `showMaskFormat` is `true.
         */
        get: function () {
            return this._foundation.useCharMask;
        },
        set: function (value) {
            this._foundation.useCharMask = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "valueMode", {
        /** Gets/sets the type for the `value` property and `tcw-datepicker-change` event. */
        get: function () {
            return this._foundation.valueMode;
        },
        set: function (value) {
            this._foundation.valueMode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "dialogWidthThreshold", {
        /** Sets the threshold for which a dialog (for mobile viewports) is used to display the calendar instead of the standard popup. */
        set: function (value) {
            this._foundation.dialogWidthThreshold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "notifyInputValueChanges", {
        /** Gets/sets whether the native input will be notified of value changes via the `input` and `change` events. */
        get: function () {
            return this._foundation.notifyInputValueChanges;
        },
        set: function (value) {
            this._foundation.notifyInputValueChanges = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "allowInvalidDate", {
        /** Gets/sets whether to allow an invalid date to be input. When true, the datepicker will not clear out the value of the input if the date was invalid (i.e. could not be parsed). */
        get: function () {
            return this._foundation.allowInvalidDate;
        },
        set: function (value) {
            this._foundation.allowInvalidDate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "parseCallback", {
        /** Sets the callback to use for parsing a date value string to a `Date` object. */
        get: function () {
            return this._foundation.parseCallback;
        },
        set: function (cb) {
            this._foundation.parseCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "formatCallback", {
        /** Sets the callback to use for formatting `Date` value to a custom string format. */
        get: function () {
            return this._foundation.formatCallback;
        },
        set: function (cb) {
            this._foundation.formatCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "prepareMaskCallback", {
        /** Sets the callback to use when altering default mask entry. */
        get: function () {
            return this._foundation.prepareMaskCallback;
        },
        set: function (cb) {
            this._foundation.prepareMaskCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "value", {
        /** Get/sets the combined value of the to and from dates */
        get: function () {
            return this._foundation.value;
        },
        set: function (value) {
            this._foundation.value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "showToday", {
        /** Gets/sets whether the today button is visible in the popup. */
        get: function () {
            return this._foundation.showToday;
        },
        set: function (value) {
            this._foundation.showToday = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateRangePickerComponent.prototype, "showClear", {
        /** Gets/sets whether the clear button is visible in the popup. */
        get: function () {
            return this._foundation.showClear;
        },
        set: function (value) {
            this._foundation.showClear = value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        FoundationProperty()
    ], DateRangePickerComponent.prototype, "disabledDaysOfWeek", void 0);
    __decorate([
        FoundationProperty({ set: true })
    ], DateRangePickerComponent.prototype, "disableDayCallback", void 0);
    __decorate([
        FoundationProperty()
    ], DateRangePickerComponent.prototype, "startView", void 0);
    DateRangePickerComponent = __decorate([
        CustomElement({
            name: DATE_RANGE_PICKER_CONSTANTS.elementName,
            dependencies: [
                PopupComponent,
                DialogComponent,
                ToolbarComponent,
                IconButtonComponent,
                ScaffoldComponent,
                CalendarComponent,
                IconComponent
            ]
        })
    ], DateRangePickerComponent);
    return DateRangePickerComponent;
}(HTMLElement));
export { DateRangePickerComponent };
